import { z } from 'zod';
/**
 * KIR-2376 — Trusted MCP servers (read-only, system-managed).
 *
 * This contract describes the response of `GET /api/system/trusted-mcps`,
 * a release-time-immutable list of MCP server vendors that Kirin trusts
 * by default. The list is consulted to gate the Phase 1 detection step
 * of the MCP server-sources scanner: a matching server skips emission
 * of `untrusted_mcp_server` but still flows through tenant block and
 * tenant allow phases.
 *
 * This is NOT a tenant `policy_exceptions` resource — entries have no
 * user/org scope, no id you can address, and cannot be mutated through
 * the API. The customer-facing override knob is a tenant `block` rule
 * created via `/policy-exceptions`.
 */
/**
 * The rule object used by the scanner's matcher. In practice every
 * trusted entry uses a `publisher` constraint (host-anchored URL,
 * scoped npm pattern, or specific package name) — that is what the
 * audit doc requires. The schema is intentionally permissive
 * (key/value string map) so future trusted entries that constrain
 * `name` or `type` continue to validate without a contract change.
 */
export const trustedMcpRuleSchema = z.record(z.string(), z.string());
export const trustedMcpServerSchema = z.object({
    vendor: z.string().min(1),
    sourceMarketplace: z.string().min(1),
    rule: trustedMcpRuleSchema,
    reason: z.string().min(1),
    evidenceUrl: z.url(),
});
export const trustedMcpServersListSchema = z.object({
    version: z.number().int().nonnegative(),
    lastReviewed: z.string().min(1),
    servers: z.array(trustedMcpServerSchema),
});
//# sourceMappingURL=trusted-mcps.js.map